import config from 'react-global-configuration';

export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const REACT_APP_VERSION = process.env.REACT_APP_VERSION || 'unknown';
export const APP_ROOT_ELEMENT_ID = 'root';
export let SEARCHKIT_HOST_URL = process.env.REACT_APP_SEARCHKIT_HOST_URL || '/api-proxy/elasticsearch-proxy?_api_proxy_uri=';

//AvO phase
export const AVO_PHASE_BEFORE = 'before'
export const AVO_PHASE_DURING = 'during'
export const AVO_PHASE_AFTER = 'after'

export const MULTILINGUAL = false;
export let APP_OPTIONS = {
  apiUrl: 'https://www.oranjefonds.nl',
  parameters: {
    env: 'production',
    multilingual: MULTILINGUAL,
    defaultLanguage: 'nl',
    siteName: 'Oranje Fonds',
    baseUtmUrls: ['https://mijn.oranjefonds.nl', 'https://formulieren.oranjefonds.nl'],
    sentryEnabled: false,
    sentryDsn: '',
    searchkitIndexAllContent: 'elasticsearch_index_drupal_meta_search',
    searchkitIndexAllContentSearch: 'elasticsearch_index_drupal_content',
    searchkitIndexAlLProjects: 'elasticsearch_index_drupal_projects',
    ctaBlockMaatjeWorden: 4,
    ctaBlockMaatjeZoeken: 5,
    ctaBlockMaatjeSignup: 6,
    avoDates: {
      startDate: new Date('2026-05-18 00:00:00').getTime() / 1000,
      endDate: new Date('2026-05-27 00:00:00').getTime() / 1000,
    },
    avoBlockIds: {
      [AVO_PHASE_BEFORE]: 16,
      [AVO_PHASE_DURING]: 17,
      [AVO_PHASE_AFTER]: 18,
    },
    privacyPagePath: '/privacyverklaring-oranje-fonds',
    cookieSettingsPath: 'http://oranjefonds.nl/cookies',
    cookiePatnersPath: 'http://oranjefonds.nl/partners',
    avoProjectOverviewUri: "/projecten",
    avoPreviousYearOverviewUri: "/voorgaande-jaren",
    avoVoteUrl: "https://formulieren.oranjefonds.nl/appeltjes-stem-sandbox",
    ctaBlockAvoPreviousYear: 16,
    overviewUrls: {
      'maatjes_story': '/mooie-verhalen-van-maatjes',
      'maatjes_find': '/ik-zoek-een-maatje-om-me-te-helpen',
    },
    mapBoxApiKey: '',
    nldoetProjectListUrl: '/resultaten-op-naam',
    nldoetUpdatesVolunteersUrl: 'https://formulieren.oranjefonds.nl/updates_nldoet_vrijwilligers_gezocht_in_mijn_gemeente',
    nldoetDates: {
      fridayStart: new Date('2024-03-14 00:00:00').getTime() / 1000,
      fridayEnd: new Date('2024-03-16 00:00:00').getTime() / 1000,
      saturdayStart: new Date('2024-03-16 00:00:00').getTime() / 1000,
      saturdayEnd: new Date('2024-03-17 00:00:00').getTime() / 1000,
    },
    nldoetProjectMapUrl: 'kaart',
    apolloSearchUrl: '/apollo/api/graphgl'
  },
  // For local dev trough a proxy:
  // apiUrl: 'http://localhost:3000/api',
};


export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);

export const IS_CLIENT = !IS_SERVER;

export let API_URL = APP_OPTIONS.apiUrl || "/api";
export let DEFAULT_LANGUAGE = APP_OPTIONS?.parameters?.defaultLanguage;
export let SITE_NAME = APP_OPTIONS?.parameters?.siteName;
export let SENTRY_DSN = APP_OPTIONS?.parameters?.sentryDsn;
export let USE_SENTRY = APP_OPTIONS?.parameters?.sentryEnabled;
export let MAPBOX_API_KEY = APP_OPTIONS?.parameters?.mapBoxApiKey;
export let BASE_URL_UTM_URLS = APP_OPTIONS?.parameters?.baseUtmUrls;

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0;
export const SCREEN_BIGMOBILE = 580;
export const SCREEN_TABLET = 808;
export const SCREEN_NORMAL = 1180;
export const SCREEN_WIDE = 1600;
export const SCREEN_HUGE = 2000;

// Domains/sites.
export const OF_DOMAIN = 'of';
export const OF_SITE_NAME = 'oranjefonds';
export const KP_DOMAIN = 'kp';
export const KP_SITE_NAME = 'kennisplatform.oranjefonds';
export const MAATJES_DOMAIN = 'maatjes_gezocht';
export const NLDOET_DOMAIN = 'nldoet';
export const BURENDAG_DOMAIN = 'burendag';
export const APPELTJES_DOMAIN = 'appeltjes';

// OF specific
export const NEWSLETTER_URL_ORGS = 'https://formulieren.oranjefonds.nl/aanmelden_mo';
export const NEWSLETTER_URL_PRIVATE = 'https://formulieren.oranjefonds.nl/nieuwsbrief_aanmelden_particulieren';
export const SUPPORT_OF_URL = 'https://formulieren.oranjefonds.nl/steun-het-vrijwilligerswerk';
export const WEBFORM_NEWSLETTER_ID = 3279;
export const NALATEN_SIDEBAR_BLOCK_ID = 1;
export const PARTICIPATION_BLOCK_ID = 7;
export const CONTACT_INFORMATION_BLOCK_ID = 8;
export const WANT_TO_KNOW_MORE_CTA_BLOCK_ID = 10;
export const SOCIAL_CTA_BLOCK_ID = 13;
export const SIDEBAR_BLOCK_ID = 14;
export const FEEDBACK_TOOL_BLOCK_ID = 15;
export const DEFAULT_FADE_DURATION_MS = 1500;
export const DEFAULT_POPUP_BANNER_EXPIRATION_DAYS = 365;

export const CONTENT_TYPE_ARTICLE = 'article';
export const CONTENT_TYPE_BASIC_PAGE = 'basic_page';
export const CONTENT_TYPE_EVENT = 'event';
export const CONTENT_TYPE_FAQ = 'faq';
export const CONTENT_TYPE_HOMEPAGE = 'homepage';
export const CONTENT_TYPE_LANDING_PAGE = 'landing_page';
export const CONTENT_TYPE_OVERVIEW_PAGE = 'overview_page';
export const CONTENT_TYPE_PARTNER = 'partner';
export const CONTENT_TYPE_PROJECT = 'project';
export const CONTENT_TYPE_VACANCY = 'vacancy';
export const CONTENT_TYPE_STORY = 'story';
export const CONTENT_TYPE_AVO_PREVIOUS_YEARS_PAGE = 'avo_previous_years_page';
export const CONTENT_TYPE_AVO_PROJECT = 'avo_project';


export const SEARCH_PATH = '/zoeken';

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_XS = 0; // xs
export const SCREEN_SM = 576; // sm
export const SCREEN_MD = 768; // md
export const SCREEN_LG = 1200; // lg
export const SCREEN_XL = 1560; // xl

// Cards.
export const CARD_SUBTITLE_MAX_LENGTH = 75;

// Maatjes specific.
export const REQUEST_TYPE_MAATJE_WORDEN = 'maatje_worden';

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': MULTILINGUAL,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'API_URL': API_URL,
  'REACT_APP_VERSION': REACT_APP_VERSION,
  'MAPBOX_USERNAME': 'oranjefondsmapbox',
  'MAPBOX_STYLENAME': 'ckvc61jwod4i714p8wudj3ume',
  // Set freeze to false to allow overwriting the configs based on the
  // options passed to window.reactFrontend
}, { freeze: false });

export const saveConstants = (options = {}) => {
  APP_OPTIONS = { ...APP_OPTIONS, ...options };

  API_URL = options.apiUrl || API_URL;
  APP_ENV = APP_OPTIONS.parameters?.env || APP_ENV;
  MAPBOX_API_KEY = APP_OPTIONS.parameters?.mapBoxApiKey || MAPBOX_API_KEY;
  BASE_URL_UTM_URLS = APP_OPTIONS.parameters?.baseUtmUrls || BASE_URL_UTM_URLS;
  USE_SENTRY = APP_OPTIONS.parameters?.useSentry || USE_SENTRY;
  SENTRY_DSN = APP_OPTIONS.parameters?.sentryDsn || SENTRY_DSN;

  let CURRENT_DOMAIN = "of";
  let CURRENT_DOMAIN_DRUPAL_IDENTIFIER = "oranjefonds_nl";
  if (API_URL.match(/kennisplatform/) !== null) {
    CURRENT_DOMAIN = "kp";
    CURRENT_DOMAIN_DRUPAL_IDENTIFIER = "kp_oranjefonds_nl";
  }
  if (API_URL.match(/maatjesgezocht/) !== null) {
    CURRENT_DOMAIN = "maatjes_gezocht";
  }
  if (API_URL.match(/burendag/) !== null) {
    CURRENT_DOMAIN = "burendag";
  }
  if (API_URL.match(/nldoet/) !== null) {
    CURRENT_DOMAIN = "nldoet";
  }
  if (API_URL.match(/appeltje/) !== null) {
    CURRENT_DOMAIN = "appeltjes";
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
    SEARCHKIT_HOST_URL = 'http://localhost:3000/search-proxy';
  }

  // Use config to share static configuration between components and packages.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': MULTILINGUAL,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'API_URL': API_URL,
    'REACT_APP_VERSION': REACT_APP_VERSION,
    'MAPBOX_USERNAME': 'oranjefondsmapbox',
    'MAPBOX_STYLENAME': 'ckvc61jwod4i714p8wudj3ume',
    'MAPBOX_API_KEY': MAPBOX_API_KEY,
    'USE_SENTRY': USE_SENTRY,
    'SENTRY_DSN': SENTRY_DSN,
    'BASE_URL_UTM_URLS': BASE_URL_UTM_URLS,
    'CURRENT_DOMAIN': CURRENT_DOMAIN,
    'CURRENT_DOMAIN_DRUPAL_IDENTIFIER': CURRENT_DOMAIN_DRUPAL_IDENTIFIER,
  });
}

export const TRANSPARENT_NAV_CONTENT_TYPE = [CONTENT_TYPE_HOMEPAGE, CONTENT_TYPE_LANDING_PAGE];
export const TEXT_BACKGROUND_COLOR_WHITE = 'white';
export const TEXT_BACKGROUND_COLOR_GRAY = 'gray';
export const TEXT_BACKGROUND_COLOR_BEIGE = 'beige';

// Menu's.
export const MENU = 'navigation'
export const MENU_OTHER = 'navigation-other'

// KP specific menu's.
export const MENU_KP = 'navigation-kp'
export const MENU_OTHER_KP = 'navigation-other-kp'
